import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Mail, Phone, Trash2, CheckCheck, X } from "lucide-react";

export default function InquiriesInbox() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(null);
    const load = () => api.get("/inquiries").then(({ data }) => setItems(data));
    useEffect(() => { load(); }, []);

    const markRead = async (id) => { await api.put(`/inquiries/${id}/read`); load(); };
    const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/inquiries/${id}`); setOpen(null); load(); };

    return (
        <div data-testid="inquiries-inbox">
            <h1 className="font-display text-4xl mb-2">Inquiries</h1>
            <p className="text-muted-foreground mb-8">Partnership requests, donations, consultancy, jobs, and general messages.</p>
            <div className="grid lg:grid-cols-12 gap-6">
                <div className="lg:col-span-5 bg-card border border-border rounded-sm overflow-hidden divide-y divide-border max-h-[70vh] overflow-y-auto">
                    {items.length === 0 && <div className="p-10 text-center text-muted-foreground">No inquiries yet.</div>}
                    {items.map((i) => (
                        <button key={i.id} onClick={() => { setOpen(i); if (!i.read) markRead(i.id); }}
                            className={`w-full text-left p-4 hover:bg-muted/40 transition-colors ${open?.id === i.id ? "bg-muted/60" : ""}`}
                            data-testid={`inquiry-${i.id}`}>
                            <div className="flex items-start justify-between gap-2 mb-1">
                                <span className="font-medium text-sm">{i.name}</span>
                                {!i.read && <span className="w-2 h-2 rounded-full bg-primary mt-1.5" />}
                            </div>
                            <div className="text-xs text-muted-foreground mb-1">{i.subject}</div>
                            <div className="text-xs text-muted-foreground line-clamp-2">{i.message}</div>
                            <div className="text-[10px] text-muted-foreground mt-2">{new Date(i.created_at).toLocaleString()}</div>
                        </button>
                    ))}
                </div>
                <div className="lg:col-span-7">
                    {open ? (
                        <div className="bg-card border border-border rounded-sm p-8" data-testid="inquiry-detail">
                            <div className="flex items-start justify-between mb-6">
                                <div>
                                    <div className="text-xs uppercase tracking-[0.18em] text-primary mb-2">{open.subject}</div>
                                    <h2 className="font-display text-3xl">{open.name}</h2>
                                    {open.organization && <div className="text-sm text-muted-foreground mt-1">{open.organization}</div>}
                                </div>
                                <button onClick={() => setOpen(null)} className="p-2 rounded-sm hover:bg-muted"><X size={16} /></button>
                            </div>
                            <div className="flex flex-wrap gap-3 mb-6 text-sm">
                                <a href={`mailto:${open.email}`} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-sm border border-border hover:border-primary/60"><Mail size={14} /> {open.email}</a>
                                {open.phone && <a href={`tel:${open.phone}`} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-sm border border-border hover:border-primary/60"><Phone size={14} /> {open.phone}</a>}
                            </div>
                            <div className="text-sm whitespace-pre-line leading-relaxed text-foreground/90 mb-8">{open.message}</div>
                            <div className="flex gap-3">
                                <button onClick={() => markRead(open.id)} className="inline-flex items-center gap-2 px-4 py-2 rounded-sm border border-border text-sm"><CheckCheck size={14} /> Mark read</button>
                                <button onClick={() => del(open.id)} className="inline-flex items-center gap-2 px-4 py-2 rounded-sm border border-destructive text-destructive text-sm"><Trash2 size={14} /> Delete</button>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-muted/30 border border-border rounded-sm p-16 text-center text-muted-foreground">Select an inquiry to read it.</div>
                    )}
                </div>
            </div>
        </div>
    );
}
